module.exports = __webpack_public_path__ + "img/delete_black_18dp.e90d39f4.svg";